<script>
import ModalDialog from '@/components/ModalDialog.vue';
import { useMessageStore } from '@/stores/message';
import { mapState } from 'pinia';
import LoadingView from './LoadingView.vue';

export default {
    data() {
        return {
            loadingFrame: true
        }
    },
    methods: {
        iframeLoaded() {
            this.loadingFrame = false
        },
        close() {
            this.$emit('close');
        }
    },
    computed: {
        ...mapState(useMessageStore, ['message'])
    },
    emits: ['close'],
    components: {
        ModalDialog,
        LoadingView
    },
    props: {
        loading: {
            type: [Boolean],
            required: true
        },
        url: {
            type: [String, null],
            required: true
        }
    }
}
</script>
<template>
    <ModalDialog v-if="!loading" :open="true" @close="close" :icon="url == null ? 'error' : false" :no-padding="url != null" :is-map="url != null" :hide-header="url != null" :vertical-scroll="url == null">
        <template v-if="url == null" #header>
            <h1 class="font-bold leading-9 font-headline antialiased ">Not Found</h1>
        </template>
        <template #body>
            <div v-if="url != null" class="w-full h-full items-center -m-3">
                <div v-if="loadingFrame" class="flex items-center justify-center h-full">
                    <LoadingView :absolute="true" />
                </div>
                <iframe class="w-screen h-screen max-h-[90vh] max-w-6xl bg-white left-0 right-0 bottom-0 top-0 m-0 rounded-lg p-1" :src="url != null ? url + (url.includes('?') ? '&' : '?') + 'isModal=true' : ''" frameborder="0" @load="iframeLoaded" />
            </div>
            <ul v-else class="flex items-center justify-center h-full">
                <li v-for="text,i in message.text" :key="i">{{ text }}</li>
            </ul>
        </template>
    </ModalDialog>
</template>
